module.exports = __webpack_public_path__ + "static/img/UNicon_preview.1130d4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/UNicon_preview.png
// module id = 6Ma/
// module chunks = 1